import { Component, Input } from '@angular/core';
import { IconCellIcon } from '@nx-fe/table';

@Component({
  selector: 'ins-icon-container',
  templateUrl: './icon-container.component.html',
  styleUrls: ['./icon-container.component.scss'],
})
export class IconContainerComponent {
  @Input()
  icon: IconCellIcon;

  @Input()
  data: any;
}
